import { Color, Spacing, Switch as SwitchComponent, Text } from '@billy/design-system'
import styled from '@emotion/styled'

export const SummarySectionWrapper = styled.div`
  align-self: flex-start;
  margin-top: -${Spacing.S40};
  padding-top: ${Spacing.S40};
  position: sticky;
  top: 0;
`

export const ContentWrapper = styled.div`
  padding: ${Spacing.S32};
  border: 1px solid ${Color.Grey200};
`

export const Content = styled(Text)`
  margin-bottom: -${Spacing.S8};
`

export const Switch = styled(SwitchComponent)`
  margin: ${Spacing.S16} 0;
`
